import React from 'react';
import Footer from '../components/Footer';
import './ApplyInput.css';

export default class ApplyInput extends React.Component {

    constructor() {
        super();
    }

    render() {

        return <div className={this.props.full?'applyInput full':'applyInput'}>
            <p style={{fontSize:16, fontWeight:600, letterSpacing:".4px", color: "hsl(220, 7%, 17%)", marginBottom:15,lineHeight:"8px"}}>{this.props.label}</p>
            <input placeholder={this.props.placeholder} value={this.props.val} onChange={(e) => this.props.onChangeText(e.target.value)} type={(this.props.type)?this.props.type:'text'} required />
        </div>
    }

}